import React from 'react';
import { motion } from 'framer-motion';
import { pageData } from './data';
import { Badge } from './ui/Badge';
import { ProductMockup } from './ui/ProductMockup';
export function Solution() {
  const {
    solution
  } = pageData;
  return <section className="py-24 px-4 relative overflow-hidden" data-id="element-145">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-[600px] bg-gold-500/5 blur-[150px] rounded-full pointer-events-none" data-id="element-146" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-147">
        <div className="text-center mb-12" data-id="element-148">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-149">
            <h2 className="text-4xl md:text-6xl mb-4 text-gold-500" data-id="element-150">
              {solution.heading}
            </h2>
            <div className="text-xl md:text-2xl font-display tracking-wide text-white mb-8" data-id="element-151">
              {solution.subheading}
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-152">
          <ProductMockup data-id="element-153" />
        </motion.div>

        <div className="max-w-3xl mx-auto text-center mt-12" data-id="element-154">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-lg md:text-xl text-slate-300 mb-8 leading-relaxed" data-id="element-155">
            {solution.description}
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-156">
            {solution.highlights.map((highlight, idx) => <span key={idx} className="text-gold-400 font-bold tracking-wide" data-id="element-157">
                {highlight}
              </span>)}
          </motion.div>
        </div>
      </div>
    </section>;
}